var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOneClick1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 82,
    viewBox: "0 0 102 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_320_624",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -32,
    y: -52,
    width: 124,
    height: 124
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.9861,
    cy: 9.9861,
    r: 61.2536,
    transform: "rotate(-78.7982 29.9861 9.9861)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_320_624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-42.4863 288.699C10.29 155.052 -12.577 -3.71165 -106.31 -92.2717",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36.4936 290.126C16.2827 156.48 9.17218 30.2834 -100.318 -90.8442",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.4331 291.042C23.3432 157.396 15.7636 28.6928 -93.2571 -89.9282",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.5581 292.886C34.3579 138.336 7.35125 0.475876 -86.3821 -88.0842",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.7314 294.634C39.0449 160.988 16.1779 2.22367 -77.5555 -86.3364",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.15672 295.738C41.9773 164.465 27.2713 24.2127 -71.9808 -85.2326",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.18994 297.117C51.5864 163.471 35.0196 46.022 -65.014 -83.8532",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40527 297.942C63.3465 169.904 33.87 27.4513 -58.4188 -83.0288",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6494 297.928C61.5442 149.755 49.3836 29.5578 -51.1747 -83.0426",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6181 299.307C72.3945 165.66 51.2727 21.2413 -44.2058 -81.6638",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3203 309.15C119.443 147.462 106.652 37.761 5.49623 -71.8201",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1201 300.595C78.8965 166.948 56.0295 8.18437 -37.7039 -80.3757",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8242 310.438C120.909 160.787 117.976 34.2108 12.0001 -70.5319",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0176 302.159C86.7939 168.512 63.927 9.74833 -29.8064 -78.8117",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7207 312.001C128.594 148.791 122.828 46.2738 19.8967 -68.9689",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9844 303.539C93.7607 169.892 86.0659 53.9592 -22.8396 -77.4316",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6894 313.383C127.951 152.044 140.78 60.4507 26.8654 -67.5874",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9521 304.918C100.728 171.272 93.4521 55.6631 -15.8719 -76.052",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6563 314.763C136.881 160.571 141.795 57.7553 33.8322 -66.2077",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7793 306.667C108.475 141.911 93.1938 41.1301 -7.04469 -74.3034",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.482 316.51C142.136 164.508 137.157 36.0781 42.6584 -64.4607",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3535 307.77C120.486 158.048 90.101 26.2764 -1.4705 -73.1999",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.058 317.613C143.95 116.351 130.464 32.0972 48.2336 -63.3569",
    stroke: "white",
    strokeOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneClick1);
export default __webpack_public_path__ + "static/media/one-click-1.6e2b7e283f087ec85d0025b016fc7c46.svg";
export { ForwardRef as ReactComponent };